<script>
    export let url;
</script>

<a href="{url}" class="button is-info has-text-weight-bold my-2">Dzieła</a>
